import React from 'react';

interface AdminInputRowProps {
  children: React.ReactNode;
  className?: string;
}

const AdminInputRow: React.FC<AdminInputRowProps> = ({
  children,
  className = ''
}) => {
  return (
    <div className={`flex justify-between gap-4 ${className}`}>
      {React.Children.map(children, (child, index) => (
        <div key={index} className="w-full">
          {child}
        </div>
      ))}
    </div>
  );
};

export default AdminInputRow;
